/**
 * Created by naidy on 9/28/2018.
 */
import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'filter'
})
export class FilterPipe implements PipeTransform {
    transform(items: any[], searchText: string): any[] {
        if(!items) return [];
        if(!searchText) return items;
        searchText = searchText.toLowerCase();
        return items.filter( it => {
            return it.message.user_name.toLowerCase().includes(searchText);
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/lib/search/filter.pipe.ts